import { render, staticRenderFns } from "./ValuePercentSplitInput.vue?vue&type=template&id=06c9eec9&scoped=true"
import script from "./ValuePercentSplitInput.vue?vue&type=script&lang=js"
export * from "./ValuePercentSplitInput.vue?vue&type=script&lang=js"
import style0 from "./ValuePercentSplitInput.vue?vue&type=style&index=0&id=06c9eec9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c9eec9",
  null
  
)

export default component.exports